import clsx from 'clsx'

import Heading from '../app/design/Heading'
import Paragraph from '../app/design/Paragraph'

type Metric = {
    title: string
    value: string
}

type KeyMetricProps = {
    metrics?: Metric[]
}

export function KeyMetric({ metrics }: KeyMetricProps) {
    if (!metrics || metrics.length === 0) return null

    const classes = metrics.length === 1 ? 'justify-start' : 'justify-around'

    return (
        <div className="rounded-lg border border-gray-300 px-6 py-4">
            <div className={`flex ${classes}`}>
                {metrics.map((m) => (
                    <div className="flex flex-col gap-1" key={m.title}>
                        <Heading size="sm" className={clsx({ 'text-center': metrics.length > 1 })}>
                            {m.value}
                        </Heading>
                        <Paragraph
                            size="md"
                            className={clsx('text-gray-600', { 'text-center': metrics.length > 1 })}
                        >
                            {m.title}
                        </Paragraph>
                    </div>
                ))}
            </div>
        </div>
    )
}
